export default "__VITE_ASSET__22f65efb__"